import { Controller } from '@hotwired/stimulus';
import Select2Cifra from '../../../components/Select2Cifra';

/*
 * Me he traído el inicializador de select2 que teníamos en los initializers y lo hacemos como
 * un controlador de stimulus para que cargue automáticamente, conecte etc.
 * Obviamente depende de select2 y, por lo tanto, jquery
 */
export default class Select2 extends Controller {
  connect() {
    this.select2Cifra = new Select2Cifra(this.element);
    this.select2Cifra.connect();
  }
}
